export class Queue<T> {
  private data: Array<T> = [];

  constructor(private limit: number) {}

  add(item: T) {
    while (this.data.length >= this.limit) {
      this.pop();
    }
    this.push(item);
  }

  private push(item: T) {
    this.data.push(item);
  }

  private pop() {
    this.data.shift();
  }

  popAll(): Array<T> {
    const old = this.data;
    this.data = [];
    return old;
  }
}
